<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">

  <!-- Page content starts -->
  <div class="common-page-contentwrap">
    <div class="col-md-12">

      <!-- Breadcrumb Section -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Subscription Plans</a></li>
        </ul>
      </div>

      <!-- Main Block -->
      <div class="block">

        <!-- Page Header -->
        <div class="page-header">
          <span class="page-header__title">Subscription Plans</span>
        </div>

        <!-- Loader Display -->
        <div *ngIf="isLoading">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>

        <!-- Tabs for Policies (only shown when data is loaded) -->
        <div class="nav_tabs_container" *ngIf="!isLoading && subscriptions.length > 0">
          <ul *ngIf="policies?.length">
            <!-- All Tab -->
            <li data-toggle="tab" class="active" (click)="filterByPolicy('ALL')">
              All
            </li>

            <!-- Dynamic Policy Tabs -->
            <li data-toggle="tab" *ngFor="let policy of policies; let i = index" (click)="filterByPolicy(policy.policyFlag)">
              <a>{{ policy.name }}</a>
            </li>
          </ul>
        </div>

        <div class="list_block">

          <!-- Subscription Cards Section -->
          <div *ngIf="!isLoading && subscriptions.length > 0">
            <div class="cards-grid">

              <!-- Single Subscription Card -->
              <div class="subscription-card" *ngFor="let subscription of filteredSubscriptions">

                <!-- Left Block: Subscription Info -->
                <div class="left-block">
                  <div class="card-details">
                    <h4 class="heading">{{ subscription?.policyDetails?.name }}</h4>
                    <span class="sub-content">
                      Subscribed on {{ subscription?.subscriptionStartDate | date: "dd-MMM-yyyy" }}
                    </span>
                    <span class="sub-content" *ngIf="subscription?.policyDetails?.policyFlag != 'BELP'">
                      Business contacts left: {{ subscription?.creditsUsed }}
                    </span>
                    <span class="sub-content">
                      Validity: {{ subscription?.durationLeft?.period }} days
                    </span>

                    <!-- Expired Date (For all except BELP) -->
                    <span class="sub-content" *ngIf="subscription?.policyDetails?.policyFlag != 'BELP'">
                      Expired on {{ subscription?.subscriptionEndDate | date: "dd-MMM-yyyy" }}
                    </span>

                    <!-- Device Count (For BELP Policy) -->
                    <span class="sub-content" *ngIf="subscription?.policyDetails?.policyFlag == 'BELP'">
                      Devices: {{ subscription?.devicesDetails?.length }}
                    </span>
                  </div>
                </div>

                <!-- Right Block: Status + Actions -->
                <div class="right-block">

                  <!-- Active / Expired Status -->
                  <div [ngClass]="{'active': subscription.isExpired == false, 'expired': subscription.isExpired == true}">
                    {{ subscription?.isExpired == false ? 'Active' : 'Expired' }}
                  </div>

                  <!-- Action: View Devices (BELP Only) -->
                  <div class="actions" *ngIf="subscription?.policyDetails?.policyFlag == 'BELP'" (click)="showDeviceDetails(subscription.id)">
                    View Devices
                  </div>
                </div>

              </div>
              <!-- End of Subscription Card -->

            </div>
          </div>

          <!-- No Data Found Message -->
          <div *ngIf="!isLoading && subscriptions.length == 0" class="noDataFoundMessage">
            Subscriptions not available
          </div>

        </div>

      </div>
      <!-- End Block -->

      <!-- Device Details Modal -->
        <div class="modal fade" id="deviceDetailsPopup" role="dialog">
          <div class="modal-dialog modal-lg notificationdiv">
            <div class="modal-content notification-modal" style="border-width: none;">

              <!-- Modal Header with Close Icon -->
              <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDeviceDetailsModal()">
                  &times;
                </button>
              </div>

              <!-- Modal Body: Device Details Table -->
              <div class="modal-body" style="position:relative">
                <div class="table-container">
                  <table class="table fixed-header-table">
                    <thead>
                    <tr>
                      <th>Device</th>
                      <th>Subscribed Date</th>
                      <th>Validity</th>
                      <th>Duration Left</th>
                    </tr>
                    </thead>
                  </table>
                  <div class="table-body-scroll">
                    <table class="table fixed-header-table">
                      <tbody>
                      <tr class="table-color" *ngFor="let device of deviceDetails">
                        <td>{{ device?.deviceNumber }}</td>
                        <td>{{ device?.bluEye?.startDate | date: "dd-MMM-yyyy" }}</td>
                        <td>{{ device?.bluEye?.validity }}</td>
                        <td>{{ device?.bluEye?.durationLeft }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!--<div class="table-container">

                  &lt;!&ndash; Table Header &ndash;&gt;
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Device</th>
                        <th>Subscribed Date</th>
                        <th>Validity</th>
                        <th>Duration Left</th>
                      </tr>
                    </thead>
                  </table>

                  &lt;!&ndash; Table Body &ndash;&gt;
                  <div class="table-body-container">
                    <table class="table">
                      <tbody>
                        <tr class="table-color" *ngFor="let device of deviceDetails">
                          <td>{{ device?.deviceNumber }}</td>
                          <td>{{ device?.bluEye?.startDate | date: "dd-MMM-yyyy" }}</td>
                          <td>{{ device?.bluEye?.validity }}</td>
                          <td>{{ device?.bluEye?.durationLeft }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>-->
              </div>
              <!-- End Modal Body -->

            </div>
          </div>
        </div>
      <!-- End Modal -->

    </div>
  </div>
</div>
